export enum Limit{
    None,
    Top,
    Bottom
}